<template>
    <div class="card z-50 grid w-full max-w-3xl gap-y-3 p-6 shadow-2xl">
        <slot />
    </div>
</template>
